// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2PWhw","requiredAsterisk":"Info_requiredAsterisk__gEbW_"};